import { ConciergeCatalogRoute } from '@/lib/pages/concierge/ConciergeCatalogRoute';
import { getConciergeCatalogServerSideProps } from '@/lib/pages/concierge/get-static-props';

import { getConciergeExcursionsCatalogPage } from '@/lib/entities/concierge/server-content';

import { InferGetServerSidePropsType } from 'next';

const PATH = '/concierge/excursions';

export default function ConciergeExcursionsPage({
  page,
  locale,
  pageSeo,
  listingRobots,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <ConciergeCatalogRoute
      page={page}
      locale={locale}
      pageSeo={pageSeo}
      listingRobots={listingRobots}
      path={PATH}
      keywords="excursions phuket concierge"
      itemCatalog="excursions"
    />
  );
}

export const getServerSideProps = getConciergeCatalogServerSideProps(
  getConciergeExcursionsCatalogPage,
  PATH
);
